import type { ReactElement } from 'react'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

/**
 * The seller's name for interpolation, or generic copy where the storefront
 * has none. Every Seller Collects string names the seller, so the fallback
 * lives in one place rather than in each of them.
 */
export const sellerNameValue = (sellerName: string): string | ReactElement =>
  sellerName || <FormattedMessage id="Listing.tags.sellerCollects.theSeller" />
